import * as React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { formatNumber } from "accounting-js";

import translation from "../../translations/translation";
import { currentLanguage } from "../../translations/CurrentLanguage";
import LocalizedStrings from "react-native-localization";
import { colors, formatMoney, radius } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

export default class ReceiptLinesComponent extends React.PureComponent {
  renderEmpty() {
    strings.setLanguage(currentLanguage().companyLanguage);
    return (
      <View style={styles.empty}>
        <View style={styles.emptyIcon}>
          <Icon name="shopping-basket" size={26} color={colors.textFaint} />
        </View>
        <Text style={styles.emptyTitle}>{strings.NoItemsYet}</Text>
        <Text style={styles.emptyText}>{strings.TapAnItemToAddIt}</Text>
      </View>
    );
  }

  renderLine(line, index) {
    const { currency, isCurrencyDisabled } = this.props;
    const money = value => formatMoney(value, currency, isCurrencyDisabled);
    // a name that ends with * is a remark, it has no quantity or price
    const isRemark = line.item_name[line.item_name.length - 1] === "*";
    const discount = line.discount_rate
      ? line.discountType === "percentage"
        ? ` (-${line.discount_rate}%)`
        : ` (-${line.discount_rate})`
      : "";

    return (
      <TouchableOpacity
        key={line._id}
        activeOpacity={0.7}
        style={styles.row}
        onPress={() => this.props.onReceiptLineEdit(index)}
      >
        {isRemark ? null : (
          <View style={styles.quantity}>
            <Text style={styles.quantityText}>
              {Number.isInteger(line.qty) ? line.qty : formatNumber(line.qty)}
            </Text>
          </View>
        )}
        <View style={styles.description}>
          <Text style={styles.name} numberOfLines={2}>
            {line.item_name}
          </Text>
          {isRemark ? null : (
            <Text style={styles.unit}>
              {money(line.price)}
              {discount}
            </Text>
          )}
        </View>
        {isRemark ? null : (
          <Text style={styles.total}>{money(line.total.toFixed(2))}</Text>
        )}
        <TouchableOpacity
          activeOpacity={0.6}
          style={styles.remove}
          onPress={() => this.props.onReceiptLineDelete(index)}
        >
          <Icon name="times" size={14} color={colors.textFaint} />
        </TouchableOpacity>
      </TouchableOpacity>
    );
  }

  render() {
    const { lines } = this.props;
    if (!lines || lines.length === 0) {
      return this.renderEmpty();
    }
    return (
      <View style={styles.list}>
        {lines.map((line, index) => this.renderLine(line, index))}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  list: {
    paddingVertical: 6,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingLeft: 20,
    paddingRight: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#f1f5f9",
  },
  quantity: {
    minWidth: 34,
    height: 34,
    paddingHorizontal: 6,
    marginRight: 12,
    borderRadius: radius.small,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primarySoft,
  },
  quantityText: {
    fontSize: 14,
    fontWeight: "700",
    color: colors.primary,
  },
  description: {
    flex: 1,
    paddingRight: 8,
  },
  name: {
    fontSize: 15,
    fontWeight: "600",
    color: colors.text,
  },
  unit: {
    marginTop: 2,
    fontSize: 13,
    color: colors.textMuted,
  },
  total: {
    fontSize: 15,
    fontWeight: "700",
    color: colors.text,
  },
  remove: {
    width: 34,
    height: 34,
    marginLeft: 6,
    borderRadius: 17,
    alignItems: "center",
    justifyContent: "center",
  },
  empty: {
    alignItems: "center",
    paddingHorizontal: 30,
    paddingTop: 70,
  },
  emptyIcon: {
    width: 68,
    height: 68,
    borderRadius: 34,
    marginBottom: 16,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f1f5f9",
  },
  emptyTitle: {
    fontSize: 16,
    fontWeight: "700",
    color: colors.text,
  },
  emptyText: {
    marginTop: 6,
    fontSize: 14,
    lineHeight: 20,
    textAlign: "center",
    color: colors.textMuted,
  },
});
